import { LuSearch, BsThreeDots } from "@/Components/Icons/Icons.jsx";

export default {
  row1: [
    {
      column: "column1",
      columnWidth: "40%",
      rows: {
        row1: [
          {
            name: "Services provided by this Organisation",
            component: "header",
          },
        ],
        row2: [
          {
            name: "isServicesBank",
            checkboxLabel: "Bank",
            component: "checkboxBox",
          },
        ],
        row3: [
          {
            name: "isServicesCFS",
            checkboxLabel: "CFS (Container Freight Station)",
            component: "checkboxBox",
          },
        ],
        row4: [
          {
            name: "isServicesContainerProvider",
            checkboxLabel: "Container Provider",
            component: "checkboxBox",
          },
        ],

        row5: [
          {
            name: "isServicesContainerTerminal",
            checkboxLabel: "Container Terminal Operator",
            component: "checkboxBox",
          },
        ],
        row6: [
          {
            name: "isServicesContainerYard",
            checkboxLabel: "Container Yard",
            component: "checkboxBox",
          },
        ],
        row7: [
          {
            name: "isServicesCustomBroker",
            checkboxLabel: "Custom Broker",
            component: "checkboxBox",
          },
        ],
        row8: [
          {
            name: "isServicesFumigationContractor",
            checkboxLabel: "Fumigation Contractor",
            component: "checkboxBox",
          },
        ],
        row9: [
          {
            name: "isServicesICD",
            checkboxLabel: "ICD (Inland Container Depo)",
            component: "checkboxBox",
          },
        ],
      },
    },
  ],
};
